import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { HiveObjectDataset } from 'app/model/dataset/hive.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { MAX_INT32 } from 'app/shared/shared-constants';

@Metamodel.model({
    name: adfModelTypeMap.hive.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(HiveObjectDataset) }
})
export class HiveCopySource extends TabularCopySource {
    public static readonly BATCH_SIZE: IAttribute;
    public static readonly QUERY_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'BATCH_SIZE',
        display: stringResources.ModelName_BatchSize,
        constraint: {
            minimum: 1,
            maximum: Number.MAX_SAFE_INTEGER
        }
    })
    public batchSize?: number = 10000;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Sec,
        constraint: {
            minimum: 1,
            maximum: MAX_INT32
        }
    })
    public queryTimeout?: number = 1800;
}
